import { cn } from '@/lib/utils';
import { Label } from './label';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: boolean;
  className?: string;
  children: React.ReactNode;
}

function FormField({ label, required, error, className, children }: FormFieldProps) {
  return (
    <div className={cn('flex w-full flex-col gap-1', className)}>
      <Label className="px-0.5 text-s text-primary-60 gap-0.5">
        {label}
        {required && <span className="text-status-danger">*</span>}
      </Label>
      <div
        className={cn(
          'flex h-7 w-full items-center rounded-md border bg-white px-2 py-1',
          'focus-within:border-highlight',
          error ? 'border-status-danger' : 'border-primary-10',
        )}
      >
        {children}
      </div>
    </div>
  );
}

export { FormField };
